import { useQuery } from '@tanstack/react-query'
import api from '../../config/axios-config'
import { membersQueryKeys } from '../constants'

/**
 * Fetches media parent data (post or task comment).
 * @param {string} projectId - ID of the project.
 * @param {string} search - Search param to use to search members.
 * @param {Object} options - Additional options for the query.
 * @returns {Object} - The query object with parent media data. The response includes a header 'dt-type'
 * that indicates whether the returned item is a media post or a media task comment, depending on where
 * the media is located.
 */

export const useGetProjectMembersQuery = (
  projectId,
  search = '',
  params = {},
  options = {}
) => {
  const handleQuery = async () => {
    const config = {
      method: 'GET',
      params: {
        size: 25,
        page: 0,
        sortBy: 'Name',
        sortDirection: 'ASC',
        company: 'All',
        ...params,
        search
      }
    }

    const { data } = await api(
      `/api/memberships-api/projects/${projectId}/members`,
      config
    )

    return data
  }

  return useQuery({
    queryKey: [membersQueryKeys.GET_PROJECT_MEMBERS, projectId, search, params],
    queryFn: handleQuery,
    enabled: !!projectId,
    ...options
  })
}
